<div class="tae-modal-backdrop" (click)="onCancel()"></div>
<div class="tae-modal json" (click)="$event.stopPropagation()">
  <div class="header">
    <div>Edit Text Animation Step (JSON)</div>
    <button class="icon" (click)="onCancel()">✕</button>
  </div>

  <div class="body">
    <div class="toolbar">
      <button (click)="onFormat()">Format</button>
      <button (click)="onReset()">Reset</button>
      <button (click)="validate()">Validate</button>
    </div>
    <textarea [(ngModel)]="text" rows="24" spellcheck="false"></textarea>
    <div class="error" *ngIf="error">{{ error }}</div>
  </div>

  <div class="footer">
    <button (click)="onCancel()">Cancel</button>
    <button class="primary" (click)="onSave()">Save</button>
  </div>
</div>

